import React from "react";
import DataTable from "../admin/DataTable";
import { PageSpinner, EmptyState } from "../admin";

const VotePackageTable = ({
  packages = [],
  loading = false,
  onEdit,
  onToggleStatus,
  onDelete,
  searchTerm = "",
  sortBy = "name",
  busyId = null,
  flashId = null,
  flashKind = "success",
}) => {
  const filteredPackages = packages.filter((pkg) =>
    pkg.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedPackages = [...filteredPackages].sort((a, b) => {
    switch (sortBy) {
      case "price":
        return a.price - b.price;
      case "type":
        return (a.type || "").localeCompare(b.type || "");
      case "name":
      default:
        return (a.name || "").localeCompare(b.name || "");
    }
  });

  if (loading) {
    return (
      <div className="card">
        <PageSpinner label="Loading packages…" />
      </div>
    );
  }

  if (sortedPackages.length === 0) {
    return (
      <div className="card">
        <EmptyState
          title="No vote packages found"
          message="Create a package to make it available for purchase."
        />
      </div>
    );
  }

  const cols = [
    { key: "name", label: "Name", render: (pkg) => <span className="text-white font-medium">{pkg.name}</span> },
    {
      key: "price",
      label: "Price",
      render: (pkg) => <span className="text-white tabular-nums">ZMW {pkg.price?.toLocaleString()}</span>,
    },
    {
      key: "type",
      label: "Type",
      render: (pkg) => (
        <span className={pkg.type === "daily" ? "badge-accent" : "badge-neutral"}>
          {pkg.type === "daily" ? "Daily" : "Weekly"}
        </span>
      ),
    },
    {
      key: "value",
      label: "Value",
      render: (pkg) => (
        <span className="text-gray-300 tabular-nums">
          {pkg.type === "daily"
            ? `${pkg.votes?.toLocaleString() || "—"} votes`
            : `${pkg.votesPerDay?.toLocaleString() || "—"} votes/day`}
        </span>
      ),
    },
    {
      key: "durationDays",
      label: "Duration",
      render: (pkg) => (
        <span className="text-gray-400 tabular-nums">
          {pkg.durationDays || 1} day{pkg.durationDays === 1 ? "" : "s"}
        </span>
      ),
    },
    {
      key: "isActive",
      label: "Status",
      render: (pkg) => (
        <button
          type="button"
          onClick={() => onToggleStatus(pkg)}
          title="Click to toggle"
          className={`badge ${pkg.isActive ? "badge-success" : "badge-neutral"} cursor-pointer hover:opacity-80 transition-opacity`}
        >
          <span
            className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
              pkg.isActive ? "bg-emerald-400" : "bg-gray-500"
            }`}
          />
          {pkg.isActive ? "Active" : "Inactive"}
        </button>
      ),
    },
  ];

  return (
    <DataTable
      cols={cols}
      rows={sortedPackages}
      keyField="packageId"
      busyId={busyId}
      busyField="packageId"
      flashId={flashId}
      flashKind={flashKind}
      rowActions={(pkg) => (
        <>
          <button type="button" onClick={() => onEdit(pkg)} className="btn-ghost !py-1.5 !px-3">
            Edit
          </button>
          <button
            type="button"
            onClick={() => onToggleStatus(pkg)}
            className={`!py-1.5 !px-3 rounded-lg text-sm font-semibold transition-colors ${
              pkg.isActive
                ? "bg-surface-600 text-gray-200 border border-line-strong hover:bg-surface-700"
                : "btn-primary"
            }`}
          >
            {pkg.isActive ? "Disable" : "Enable"}
          </button>
          <button type="button" onClick={() => onDelete(pkg)} className="btn-danger !py-1.5 !px-3">
            Delete
          </button>
        </>
      )}
    />
  );
};

export default VotePackageTable;
